import { generateUtilityClass, generateUtilityClasses } from '@mui/base';
export function getCollapseUtilityClass(slot) {
  return generateUtilityClass('MuiCollapse', slot);
}
const collapseClasses = generateUtilityClasses('MuiCollapse', ['root', 'horizontal', 'vertical', 'entered', 'hidden', 'wrapper', 'wrapperInner']);
export default collapseClasses;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/material/Collapse/collapseClasses.js
// module id = 254
// module chunks = 1